
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/quizTemplatePage",
      function () {
        return require("private-next-pages/templates/quizTemplatePage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/templates/quizTemplatePage"])
      });
    }
  